import React from 'react';
import { useTranslation } from 'react-i18next';
import { Colors } from '../../themes/colors';
import { MultiItemSelector } from '../forms/multiItemSelector';

type Group = {
  id: string;
  name: string;
};

type GroupSelectorProps = {
  selectedGroups: Group[];
  availableGroups: Group[];
  onGroupsChange: (groups: Group[]) => void;
  onCreateGroup?: (name: string) => Promise<Group>;
  createLockedMessage?: string;
  disabled?: boolean;
  onSelectorEdit?: () => void;
};

export const GroupSelector: React.FC<GroupSelectorProps> = ({
  selectedGroups,
  availableGroups,
  onGroupsChange,
  onCreateGroup,
  createLockedMessage,
  disabled = false,
  onSelectorEdit,
}) => {
  const { t } = useTranslation();

  return (
    <MultiItemSelector
      selectedItems={selectedGroups}
      availableItems={availableGroups}
      onItemsChange={onGroupsChange}
      onCreateItem={onCreateGroup}
      createLockedMessage={createLockedMessage}
      disabled={disabled}
      placeholder={t('groups.common.selectGroup')}
      searchPlaceholder={t('groups.common.searchGroup')}
      createButtonText={t('groups.common.createGroup')}
      containerBackgroundColor={Colors.role.surface}
      itemType="group"
      emptyText={t('groups.common.emptyStateMessage')}
      onSelectorEdit={onSelectorEdit}
    />
  );
};
